var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52 16.93a1.335 1.335 0 1 1 0 2.672 1.335 1.335 0 0 1 0-2.671ZM14.752 16.93a1.335 1.335 0 1 1 0 2.671 1.335 1.335 0 0 1 0-2.67ZM5.627 11.59c0-1.278.001-2.17.092-2.842.088-.653.248-.999.495-1.245.246-.247.592-.407 1.245-.495.673-.09 1.564-.092 2.842-.092h2.597c1.484 0 2.525.002 3.3.111.755.108 1.132.303 1.381.597.25.295.38.7.362 1.462-.019.781-.188 1.809-.432 3.272-.18 1.083-.307 1.834-.475 2.397-.162.545-.341.833-.578 1.034-.238.201-.552.33-1.116.401-.583.073-1.344.074-2.442.074h-2.597c-1.278 0-2.17-.001-2.842-.092-.653-.088-.999-.248-1.245-.495-.247-.246-.407-.592-.495-1.245-.09-.673-.092-1.564-.092-2.842Z",
    stroke: "#1E5DFF",
    strokeWidth: 1.669
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.627 11.145V5.358a1.78 1.78 0 0 0-1.78-1.78H2.732",
    stroke: "#1E5DFF",
    strokeWidth: 1.669,
    strokeLinecap: "round"
  })));
};
export default SvgBasket;